import { Form, Input } from "antd"
import React from "react"

interface SignatureDateBlockProps {
  fieldKey: string
  initialValue?: string
}

export function SignatureDateBlock({
  fieldKey,
  initialValue
}: SignatureDateBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "signer_label"]}
        label="Signature Label"
        initialValue={initialValue}
      >
        <Input placeholder="e.g. Client Signature" />
      </Form.Item>
    </>
  )
}
